import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "jalali-moment";
import { HiOutlineArrowLongLeft } from "react-icons/hi2";
import useStore from "../../features/store";
import DashboardLayout from "../../layout/dashboardLayout";
import Statistics from "../../components/dashboard/statistics";
import ProfileList from "../../components/dashboard/profileList";
import TestList from "../../components/dashboard/testList";
import ProfilesCount from "../../components/dashboard/profilesCount";
import ProfileAgeChart from "../../components/dashboard/profileAgeChart";

const Dashboard = () => {
  const {
    profile,
    fetchStatistical,
    statistical,
    isLoadingStatistical,
    fetchBirthyearStats,
    birthyearStats,
    isLoadingBirthyearStats,
    profiles,
    isLoadingProfiles,
    fetchProfiles,
    tests,
    isLoadingTests,
    fetchTests,
    invalidComponents,
    isLoadingInvalidComponents,
    fetchInvalidComponents,
    messagesFeedbacks,
    messagesTickets,
    isLoadingMessages,
    fetchMessages,
    fetchProfilesCount,
    profilesCount,
    isLoadingProfilesCount,
  }: any = useStore();
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);

  const fetchStaticData = (
    start_date: string | null,
    end_date: string | null
  ) => {
    fetchStatistical(start_date, end_date);
  };

  const fetchBirthyearStatsData = (
    start_date: string | null,
    end_date: string | null
  ) => {
    fetchBirthyearStats(start_date, end_date);
  };

  useEffect(() => {
    if (profile) {
      if (!statistical) fetchStaticData(null, null);
      if (!birthyearStats) fetchBirthyearStatsData(null, null);
      if (!profiles && !isLoadingProfiles) fetchProfiles("1");
      if (!tests && !isLoadingTests) fetchTests("1");
    }
  }, [profile, statistical, profiles, tests]);

  useEffect(() => {
    if (profile) {
      if (!invalidComponents) {
        fetchInvalidComponents();
      }
    }
  }, [profile, invalidComponents]);

  useEffect(() => {
    if (profile) {
      if (!messagesTickets) {
        fetchMessages("contact_us");
      }
    }
  }, [profile, messagesTickets]);

  useEffect(() => {
    if (profile) {
      if (!profilesCount) {
        const start_date = moment().subtract(1, "month").format("YYYY-MM-DD");
        const end_date = moment().format("YYYY-MM-DD");

        fetchProfilesCount(start_date, end_date);
      }
    }
  }, [profile, profilesCount, fetchProfilesCount]);

  return (
    <DashboardLayout>
      <div>
        <Statistics
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          fetchStaticData={fetchStaticData}
          statistical={statistical}
          isLoadingStatistical={isLoadingStatistical}
          birthyearStats={birthyearStats}
          messagesTickets={messagesTickets}
          isLoadingMessages={isLoadingMessages}
          invalidComponents={invalidComponents}
          isLoadingInvalidComponents={isLoadingInvalidComponents}
          isLoadingBirthyearStats={isLoadingBirthyearStats}
          fetchBirthyearStatsData={fetchBirthyearStatsData}
        />
      </div>

      <div className="flex flex-col lg:flex-row justify-between items-center gap-2 mt-14">
        <div className="flex-[1] w-full">
          <h2 className="font-rokh font-[900] lg:text-2xl mt-3">
            تعداد کاربران بر اساس سن:
          </h2>
          {birthyearStats?.length > 0 && (
            <p className="font-[700] font-rokh mb-3 text-right">
              از بین کاربران بادی‌بان،{" "}
              <strong className="font-[900] font-rokh">
                {
                  birthyearStats.find((item: any) => item.age_users === null)
                    .count
                }{" "}
              </strong>
              نفر تاریخ تولد خود را وارد نکرده‌اند.
            </p>
          )}

          <div className="bg-pr_white border py-6 lg:px-2 lg:pt-8 pb-1 rounded-xl w-full">
            <div className="flex items-center justify-center">
              <ProfileAgeChart
                birthyearStats={birthyearStats}
                isLoadingBirthyearStats={isLoadingBirthyearStats}
              />
            </div>
          </div>
        </div>

        <div className="flex-[1] w-full lg:mt-0 mt-10">
          <h2 className="font-rokh font-[900] lg:text-2xl mt-3">
            تعداد ثبت‌نام سی روز گذشته در بادی‌بان:
          </h2>
          {profilesCount?.length > 0 && (
            <p className="font-[700] font-rokh mb-3 text-right">
              در سی روز گذشته،{" "}
              <strong className="font-[900] font-rokh">
                {profilesCount.reduce(
                  (total: any, item: any) => total + item.count,
                  0
                )}{" "}
              </strong>
              کاربر در بادی‌بان ثبت‌نام کرده‌اند.
            </p>
          )}
          <div className="bg-pr_white border py-6 lg:px-2 lg:pt-8 pb-1 rounded-xl w-full">
            <div className="flex items-center justify-center">
              <ProfilesCount
                profilesCount={profilesCount}
                isLoadingProfilesCount={isLoadingProfilesCount}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="my-20">
        <div className="flex justify-between items-center pb-3">
          <h1 className="font-rokh font-[900] lg:text-2xl mt-2">
            کاربران جدید:
          </h1>
          <Link
            to="/dashboard-profiles?page=1"
            className="btn bg-pr_primary hover:bg-pr_blue_dark btn-sm lg:btn-base text-white"
          >
            مشاهده لیست کاربران
            <HiOutlineArrowLongLeft size={30} className="mr-3 hidden lg:flex" />
          </Link>
        </div>
        <div className="rounded-xl overflow-hidden bg-white border-[1px] border-gray-100">
          {profiles && <ProfileList data={profiles} count={10} />}
        </div>
      </div>

      <div className="my-20">
        <div className="flex justify-between items-center pb-3">
          <h1 className="font-rokh font-[900] lg:text-2xl mt-2">
            آخرین آزمایش‌ها:
          </h1>
          <Link
            to="/dashboard-tests?page=1"
            className="btn bg-pr_primary hover:bg-pr_blue_dark btn-sm lg:btn-base text-white"
          >
            مشاهده لیست آزمایش‌ها
            <HiOutlineArrowLongLeft size={30} className="mr-3 hidden lg:flex" />
          </Link>
        </div>
        <div className="rounded-xl overflow-hidden bg-white border-[1px] border-gray-100">
          {tests && <TestList data={tests} count={10} />}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Dashboard;
